import { bindAbortListeners } from '@atlaskit/react-ufo/ssr-scripts';

// Runs before the HTML body, it is NOT safe to assume SSR has been successful rendered
// This is why we don't check for `window.__SSR_RENDERED__` here
bindAbortListeners(document, window);
